var $fce709921e2c0fa6$exports = {};
$fce709921e2c0fa6$exports = {
  "dismiss": "Zignoruj"
};
export { $fce709921e2c0fa6$exports as default };